<form [formGroup]="form" *ngIf="!form.controls.input.disabled">
  <mat-form-field appearance="outline" class="mat-form-field"
    ><mat-select formControlName="input">
      <mat-option *ngFor="let option of answerOptions" [value]="option.name">
        {{ option.label }}
      </mat-option>
    </mat-select>
  </mat-form-field>
  <div
    *ngIf="trainingAnswerLabel$ | async as trainingAnswerLabel"
    class="training-answer body-01"
  >
    <h3-training-answer-icon></h3-training-answer-icon>
    {{ trainingAnswerLabel }}
  </div>
</form>
<p class="read-only-text" *ngIf="form.controls.input.disabled">
  {{ readOnlyText$ | async }}
</p>
